/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/shared/device_profile_type';
import '../model/shared/device_profile_template_type';
import './status';
import '../model/shared/device_profile';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "DuplicateDeviceProfileV2Request": {
                        "fields": {
                          "deviceProfileId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "name": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "targetProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "ignoreTypeCompatibility": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          },
                          "modeDuplicationRstTemplateType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileTemplateType",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "DuplicateDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "deviceProfile": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.DuplicateDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.DuplicateDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DuplicateDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/duplicate_device_profile.proto at 15:1
 */
export const DuplicateDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.DuplicateDeviceProfileV2Request');
fixType(DuplicateDeviceProfileV2Request, {
  deviceProfileId: {
    required: true
  },
  name: {
    notEmpty: true
  },
  targetProfileType: {
    required: true
  }
});
Builder.createAndAttachToType(DuplicateDeviceProfileV2Request);
/**
 * SOURCE DuplicateDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/duplicate_device_profile.proto at 30:1
 */
export const DuplicateDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.DuplicateDeviceProfileV2Response');
fixType(DuplicateDeviceProfileV2Response);
Builder.createAndAttachToType(DuplicateDeviceProfileV2Response);